import React from 'react';
import { ChevronDown } from 'lucide-react';

const zamanAsimiSureleri = [
  { label: '30 yıl', value: 30, description: 'Ağırlaştırılmış müebbet hapis cezasını gerektiren suçlarda' },
  { label: '25 yıl', value: 25, description: 'Müebbet hapis cezasını gerektiren suçlarda' },
  { label: '20 yıl', value: 20, description: 'Yirmi yıldan aşağı olmamak üzere hapis cezasını gerektiren suçlarda' },
  { label: '15 yıl', value: 15, description: 'Beş yıldan fazla ve yirmi yıldan az hapis cezasını gerektiren suçlarda' },
  { label: '8 yıl', value: 8, description: 'Beş yıldan fazla olmamak üzere hapis veya adlî para cezasını gerektiren suçlarda' },
];

function ZamanAsimiSuresiSecimi({ value, onChange }) {
  const secili = zamanAsimiSureleri.find((s) => s.value === value);

  return (
    <div>
      <label className="mb-1.5 flex h-7 items-center text-sm font-medium text-slate-700">
        Zamanaşımı süresi (66/1)
      </label>
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          className="w-full appearance-none rounded-lg border border-slate-300 bg-white px-3 py-2.5 pr-9 text-sm text-slate-900 shadow-sm transition-colors focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30"
        >
          {zamanAsimiSureleri.map((sure) => (
            <option key={sure.value} value={sure.value}>
              {sure.label}
            </option>
          ))}
        </select>
        <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
      </div>
      {secili ? <p className="mt-1.5 text-xs text-slate-500 leading-snug">{secili.description}</p> : null}
    </div>
  );
}

export default ZamanAsimiSuresiSecimi;
